import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

import { AppletProps } from "./types";

import { AppletWrapper } from "~/Atom/AppletWrapper";
import { LocationCard } from "~/Atom/LocationCard";
import { isDevelopment } from "~/env";
import { useFlag } from "~/LaunchDarkly";
import { useOmnichannelApi } from "~/OmnichannelApi";
import { Components } from "~/OmnichannelApi/openapi";

const Applet: React.FC<AppletProps> = ({
  locationSlug,
  take,
  lat: initialLat,
  lon: initialLon,
}) => {
  const hasAuthorization = useFlag("applet-es-locations-nearby");
  const [nearbyLocations, setNearbyLocations] = useState<
    Array<Components.Schemas.LocationFinderLocation | undefined>
  >(new Array(take).fill(undefined));
  const api = useOmnichannelApi();

  const [lat, setLat] = useState<number | undefined>(
    isNaN(Number(initialLat)) ? undefined : Number(initialLat)
  );
  const [lon, setLon] = useState<number | undefined>(
    isNaN(Number(initialLon)) ? undefined : Number(initialLon)
  );
  useEffect(() => {
    if (lat === undefined && lon === undefined) {
      if (locationSlug) {
        api["location-finder.search"](undefined, {
          must: { slug: locationSlug },
        }).then((res) => {
          setLat(res.data.locations.at(0)?.geo.latitude);
          setLon(res.data.locations.at(0)?.geo.longitude);
        });
      } else {
        if (window.getGeo) {
          window.getGeo().then((data) => {
            setLat(Number(data.latitude));
            setLon(Number(data.longitude));
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (lat !== undefined && lon !== undefined) {
      api["location-finder.search"](undefined, {
        filter: { radius: { lat, lon, distance_miles: 2000 } },
        sort: {
          distance: {
            lat,
            lon,
          },
        },
        take: locationSlug ? take + 1 : take,
      }).then((res) => {
        setNearbyLocations(
          res.data.locations
            .filter(({ slug }) => slug !== locationSlug)
            .slice(0, take)
        );
      });
    }
  }, [lat, lon]);

  if (hasAuthorization !== true) {
    if (isDevelopment) {
      console.error("Unauthorized to access applet.");
    }

    return null;
  }

  return (
    <AppletWrapper appletName="locations-nearby">
      <Row gutter={[32, 32]}>
        {nearbyLocations.map((location, idx) => (
          <Col xs={24} lg={8} key={idx}>
            <LocationCard location={location} />
          </Col>
        ))}
      </Row>
    </AppletWrapper>
  );
};

export const mount = (el: HTMLDivElement) => {
  const root = createRoot(el);

  const getAttr = (attr: string, defaultValue?: string) =>
    el.getAttribute(attr) || defaultValue;

  const props: AppletProps = {
    locationSlug: getAttr("locationslug", undefined),
    take: Number(getAttr("take", "3")),
    lat: getAttr("lat", undefined),
    lon: getAttr("lon", undefined),
  };

  root.render(<Applet {...props} />);
};
